// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1l4Pm","header":"MergedInvoice_header__1Y65p"};